import { api } from "./api";

interface LoginResponse {
    accessToken: string;
    ttl: number;
}

const listeners: Set<(isAuthenticated: boolean) => void> = new Set();

const notifyListeners = (isAuthenticated: boolean) => {
    listeners.forEach((listener) => listener(isAuthenticated));
};

export const authService = {
    login: async (username: string, password: string): Promise<LoginResponse> => {
        try {
            const response = await api.post<LoginResponse>("/login", { username, password });
            if (response.accessToken) {
                api.setToken(response.accessToken);
                localStorage.setItem("token", response.accessToken);
                // Calculate expiry date: current time + ttl in ms - 10 minutes buffer
                const expiryDate = Date.now() + response.ttl * 1000 - 10 * 60 * 1000;
                localStorage.setItem("session_expiry", expiryDate.toString());
                localStorage.removeItem("ttl");
                notifyListeners(true);
            }
            return response;
        } catch (error) {
            notifyListeners(false);
            throw error;
        }
    },

    logout: () => {
        api.setToken("");
        localStorage.removeItem("token");
        localStorage.removeItem("session_expiry");
        notifyListeners(false);
    },

    isLoggedIn: (): boolean => {
        const token = localStorage.getItem("token");
        const expiry = localStorage.getItem("session_expiry");

        if (!token || !expiry) {
            return false;
        }

        if (Date.now() >= parseInt(expiry, 10)) {
            // Session expired — clear stale credentials so UI and API stay in sync.
            api.setToken("");
            localStorage.removeItem("token");
            localStorage.removeItem("session_expiry");
            return false;
        }

        return true;
    },

    subscribe: (listener: (isAuthenticated: boolean) => void) => {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
};
